var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.662 4.3092L16.0679 2.90253C16.3609 2.60947 16.7584 2.44482 17.1729 2.44482C17.5873 2.44482 17.9848 2.60947 18.2779 2.90253C18.5709 3.19559 18.7356 3.59307 18.7356 4.00753C18.7356 4.42199 18.5709 4.81947 18.2779 5.11253L9.42869 13.9617C8.98812 14.402 8.44482 14.7256 7.84785 14.9034L5.61035 15.57L6.27702 13.3325C6.45475 12.7356 6.77838 12.1923 7.21868 11.7517L14.662 4.3092ZM14.662 4.3092L16.8604 6.50753M15.6104 12.2367V16.195C15.6104 16.6923 15.4128 17.1692 15.0612 17.5209C14.7095 17.8725 14.2326 18.07 13.7354 18.07H4.98535C4.48807 18.07 4.01116 17.8725 3.65953 17.5209C3.3079 17.1692 3.11035 16.6923 3.11035 16.195V7.44503C3.11035 6.94775 3.3079 6.47084 3.65953 6.11921C4.01116 5.76757 4.48807 5.57003 4.98535 5.57003H8.94369",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.77e4ba26988f73f253de9faa16c68964.svg";
export { ForwardRef as ReactComponent };